import React from "react";
import RoomData from "../../../interfaces/robot/rooms/room-data";
import ZoneControllerMouseState from "../../../enums/robot/zone-planner/zone-controller-mouse-state";
import { useSharedSelector } from "../../../store/SharedProvider";
import { selectSelectedRoomLimitZone } from "../../../store/room/room-selectors";
import ZonePointType from "../../../enums/robot/rooms/zone-point-type";
import { zonePointsToSvgString } from "../../../utils/map/zone-helper";
import ZonePointHandles from "./ZonePointHandles";

const RoomLimitZoneSvgPolygon: React.FC<{
  roomData: RoomData;
  scale: number;
  mouseState?: ZoneControllerMouseState;
}> = ({ roomData, scale, mouseState = ZoneControllerMouseState.Default }) => {
  const zone = useSharedSelector((state) => selectSelectedRoomLimitZone(state));

  if (zone == null) {
    return null;
  }

  const polygonPoints = zonePointsToSvgString(zone.points, roomData);

  return (
    <React.Fragment>
      {/* Boundary polygon border */}
      <polygon
        points={polygonPoints}
        style={{ fillOpacity: 0, strokeOpacity: 0.8, pointerEvents: "visible", stroke: "black" }}
        strokeWidth={1 / scale}
      />

      {/* Corner + mid-point handles (hidden while dragging the whole polygon) */}
      {mouseState !== ZoneControllerMouseState.DragRoomLimitationZone && (
        <ZonePointHandles
          zonePoints={zone.points}
          roomData={roomData}
          scale={scale}
          midPointType={ZonePointType.RoomLimitZonePointMidPoint}
          enlargeCornerHandlesOnHover={true}
          isRoomLimitZonePoint={true}
        />
      )}
    </React.Fragment>
  );
};

export default RoomLimitZoneSvgPolygon;
